<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{'menuitem.sms-template' | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Filtreleme ve Arama -->
  <div class="card mb-4 border-0 shadow-sm">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-6">
          <div class="form-group">
            <label class="custom-form-label" for="storeSelect">{{'store.storeName' | translate}}</label>
            <select name="storeSelect" [(ngModel)]="selectedStoreId" class="form-control" (ngModelChange)="getData()">
              <option [ngValue]="0">
                {{'store.allStores' | translate}}
              </option>

              <option *ngFor="let option of stores" [ngValue]="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-bold" for="search">
            {{'hint.search-in-result' | translate}}
          </label>
          <div class="input-group">
            <input class="form-control" type="text" name="search" [(ngModel)]="searchText" placeholder="{{'hint.search-in-result' | translate}}" appUppercase autocompleteOff>
            <button class="btn btn-outline-secondary" type="button" (click)="searchText = ''; getData()">
              <i class="fa fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="showOnlyCustom" [(ngModel)]="showOnlyCustom" (ngModelChange)="onShowOnlyCustomChange()">
            <label class="form-check-label" for="showOnlyCustom">
              {{'hint.showOnlyCustomSmsTemplate' | translate}}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Template Listesi -->
  <div class="row g-3" *ngIf="!loading">
    <div class="col-md-4 col-lg-4" *ngFor="let template of dataList | searchGlobal: searchText">
      <div class="card h-100 border-0 shadow-sm" [ngClass]="{'border-start border-warning border-4': template.usageFor === 'CUSTOM'}">
        <div class="card-header py-1 px-2 small">
          <div class="d-flex align-items-center">
            <span class="badge bg-warning text-dark" *ngIf="template.usageFor === 'CUSTOM'">
              {{ template.usageFor }}
            </span>
            <span *ngIf="template.usageFor === 'CUSTOM'" class="ms-2">
              {{ template.name || 'Özel Şablon' }}
            </span>
            <span *ngIf="template.usageFor !== 'CUSTOM'" class="fw-bold">
              {{ template.name || template.usageFor }}
            </span>
          </div>
        </div>

        <div class="card-body py-1 px-2">
          <p class="mb-0 text-break template-message small" [title]="template.message">
            {{ template.message }}
          </p>
        </div>

        <div class="card-footer bg-transparent py-1 px-2">
          <div class="d-flex gap-1">
            <button type="button" class="btn btn-sm btn-primary flex-fill" (click)="selectRecord(template)">
              {{'button.select' | translate}}
            </button>
            <button *ngxPermissionsOnly="[roleCodeEnum.SMS_TEMPLATE_UPDATE]" class="btn btn-sm btn-outline-secondary" (click)="openAddUpdateModal(template)">
              {{'button.update' | translate}}
            </button>
            <button *ngxPermissionsOnly="[roleCodeEnum.SMS_TEMPLATE_DELETE]" type="button" class="btn btn-sm btn-outline-danger" (click)="delete(template)">
              {{'button.delete' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="text-center py-4" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Boş Liste -->
  <app-no-record *ngIf="!loading && (!dataList || dataList.length === 0)" [showCard]="false" customMessage="message.info.norecords-found" icon="fa-inbox"></app-no-record>
</div>

<div class="modal-footer">
  <div class="d-flex gap-2 w-100 justify-content-end">
    <button type="button" class="btn btn-secondary" (click)="close()">
      {{'button.close' | translate}}
    </button>

    <button *ngxPermissionsOnly="[roleCodeEnum.SMS_TEMPLATE_CREATE]" class="btn btn-primary" (click)="openAddUpdateModal()">
      {{'button.add-new' | translate}}
    </button>
  </div>
</div>